var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "16", height: "31", viewBox: "0 0 16 31", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.905 18.7031L8 13.7945L2.09497 18.7031C1.56995 19.1395 0.771938 19.089 0.312551 18.5902C-0.146836 18.0914 -0.0936346 17.3333 0.431379 16.8969L7.16821 11.2969C7.64445 10.901 8.35555 10.901 8.83179 11.2969L15.5686 16.8969C16.0936 17.3333 16.1468 18.0914 15.6874 18.5902C15.2281 19.089 14.43 19.1395 13.905 18.7031Z", fill: "#303030" })
  );
});